/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import AppComponent from './main';
import AppCallback from './callback/main';
import AppInstall from './install/main';
import AppUninstall from './uninstall/main';

export const index = (context, next) => {
    context.primary = <AppComponent  />;
    next();
};

export const callback = (context, next) => {
    context.primary = <AppCallback />;
    next();
};

export const install = (context, next) => {
    context.primary = <AppInstall />;
    next();
};

export const uninstall = (context, next) => {
    context.primary = <AppUninstall />;
    next();
};